module.exports = __webpack_public_path__ + "img/1F1E6-1F1F7.65631080.svg";